export default __webpack_public_path__ + "static/softserves-7dbda05a800a678aa1d9000b92fea72f.png";